<mat-form-field appearance="outline">
  <div class="icon icon-search" matPrefix ></div>
  <input
    type="text"
    class="wider-options"
    placeholder="Search by location"
    matInput
    [formControl]="locationSearchCtrl"
    [matAutocomplete]="auto">
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="goToLocation($event)"
      [displayWith]="displayAddress"
      panelWidth="250px"
      class="address-search-options">
      <div class="horizontal-separator"></div>
      @for (option of locations$ | async; track option) {
        <mat-option [value]="option" >
          {{ option.formatted_address }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (locationSearchCtrl.value) {
      <div class="icon icon-small-close" matSuffix (click)="clearSearch()"></div>
    }
  </mat-form-field>